import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import BasicButton from "@components/core/buttons/BasicButton";
import parse from "html-react-parser";
import DateFormat from "@utils/DateFormat";
import { setOnboardingToFalse } from "@state/auth/AuthEvents";
import { ROUTES } from "@routes/Routes";
import { useNavigate } from "react-router-dom";
import { LogoutDetailsDto } from "@state/logoutDetails/dto/response/logout.details.mode.dto";

interface OBSignatureDelegationSoonExpirationPageProps {
  logoutDetails: LogoutDetailsDto | null;
  signatureDelegationusExpirationDate: Date;
  className?: string;
}

const OBSignatureDelegationSoonExpirationPage: FunctionComponent<
  OBSignatureDelegationSoonExpirationPageProps
> = ({
  logoutDetails,
  signatureDelegationusExpirationDate,
  className = "",
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div
      className={`app-onboarding onboarding-signature-delegation-soon-expiration ${className}`}
    >
      <h3 className="mb-16">
        {parse(
          t("onboarding.renewSignatureDelegation.title", {
            date: DateFormat.certificateDate(
              signatureDelegationusExpirationDate,
            ),
          }),
        )}
      </h3>
      <p>
        <i>
          {parse(
            t("onboarding.renewSignatureDelegation.message1", {
              url: logoutDetails && logoutDetails.urlAccount,
            }),
          )}
        </i>
      </p>
      <p>
        <strong>
          {parse(
            t("onboarding.renewSignatureDelegation.message2", {
              date: DateFormat.certificateDate(
                signatureDelegationusExpirationDate,
              ),
            }),
          )}
        </strong>
      </p>
      <p>{parse(t("onboarding.renewSignatureDelegation.message3"))}</p>
      <div className="d-flex align-items-center gap-8">
        <BasicButton
          variant="tertiary"
          text={t("onboarding.renewSignatureDelegation.checkDelegationsOnCE")}
          onClick={(e) => {
            e.preventDefault();
            if (logoutDetails) {
              window.open(logoutDetails.urlAccount, "_blank");
            }
            setOnboardingToFalse();
            navigate(ROUTES.extranet.home.generate());
          }}
        />
        <BasicButton
          variant="primary"
          text={t("onboarding.renewSignatureDelegation.ok")}
          onClick={(e) => {
            e.preventDefault();
            setOnboardingToFalse();
            navigate(ROUTES.extranet.home.generate());
          }}
        />
      </div>
    </div>
  );
};

export default OBSignatureDelegationSoonExpirationPage;
